export default __webpack_public_path__ + "static/media/isa-bg3.cedc642a.jpg";